import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

const authority = process.env.VUE_APP_AUTHORITY || 'https://auth.garantepay.net.br'
const clientId = process.env.VUE_APP_OIDC_CLIENT_ID || '7b4d1e9b-c3cd-4b8b-8c34-e50914bea1da'
const scope = process.env.VUE_APP_OIDC_SCOPE || 'openid profile email roles process_api'
const redirectPath = process.env.VUE_APP_OIDC_REDIRECT_PATH || '/callback'
const postLogoutPath = process.env.VUE_APP_OIDC_POST_LOGOUT_PATH || '/'
const redirectUri = process.env.VUE_APP_OIDC_REDIRECT_URI || `${getOrigin()}${redirectPath}`
const postLogoutRedirectUri = process.env.VUE_APP_OIDC_POST_LOGOUT_REDIRECT_URI || `${getOrigin()}${postLogoutPath}`

function getOrigin() {
  return window.location.origin
}

const userManager = new UserManager({
  authority,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code',
  scope,
  loadUserInfo: false,
  monitorSession: false,
  automaticSilentRenew: false,
  revokeTokensOnSignout: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage })
})

async function getUser() {
  return userManager.getUser()
}

async function isAuthenticated() {
  const user = await getUser()
  return Boolean(user && !user.expired && user.access_token)
}

async function getAccessToken() {
  const user = await getUser()
  return user && !user.expired ? user.access_token : null
}

async function signInRedirect(returnPath) {
  const target = returnPath || `${window.location.pathname}${window.location.search}${window.location.hash}`
  return userManager.signinRedirect({
    state: { returnPath: target === '/' ? '/Home' : target }
  })
}

async function completeSignInRedirect() {
  const user = await userManager.signinRedirectCallback()
  const returnPath = user?.state?.returnPath
  return typeof returnPath === 'string' && returnPath ? returnPath : '/Home'
}

async function signOutRedirect() {
  const user = await getUser()
  const idToken = user?.id_token
  localStorage.removeItem('_useravgar')
  sessionStorage.removeItem('avisoSistemaFechado')

  try {
    return await userManager.signoutRedirect({
      id_token_hint: idToken,
      post_logout_redirect_uri: postLogoutRedirectUri
    })
  } catch (error) {
    await userManager.removeUser()
    const logoutUrl = new URL(`${authority}/connect/logout`)

    if (idToken) {
      logoutUrl.searchParams.set('id_token_hint', idToken)
    }

    logoutUrl.searchParams.set('post_logout_redirect_uri', postLogoutRedirectUri)
    window.location.assign(logoutUrl.toString())
  }
}

async function clearAuthState() {
  await userManager.removeUser()
  localStorage.removeItem('_useravgar')
}

export default {
  authority,
  clientId,
  scope,
  getUser,
  isAuthenticated,
  getAccessToken,
  signInRedirect,
  completeSignInRedirect,
  signOutRedirect,
  clearAuthState
}
